export let saturdayUppercase = "beEA3b";
export default {saturdayUppercase};